import { z } from 'zod';

export const supplierFormSchema = z
  .object({
    name: z
      .string()
      .min(1, 'Tên nhà cung cấp là bắt buộc')
      .max(100, 'Tên nhà cung cấp không được vượt quá 100 ký tự')
      .refine(
        (val) => val.trim().length > 0,
        'Tên nhà cung cấp không được chỉ chứa khoảng trắng'
      ),
    address: z
      .string()
      .min(1, 'Địa chỉ là bắt buộc')
      .max(100, 'Địa chỉ không được vượt quá 100 ký tự')
      .refine(
        (val) => val.trim().length > 0,
        'Địa chỉ không được chỉ chứa khoảng trắng'
      ),
    taxCode: z
      .number({
        invalid_type_error: 'Mã số thuế là bắt buộc',
        required_error: 'Mã số thuế là bắt buộc',
      })
      .min(1, 'Mã số thuế là bắt buộc'),
    phone: z
      .string()
      .min(1, 'Số điện thoại là bắt buộc')
      .max(20, 'Số điện thoại không được vượt quá 20 ký tự')
      .refine(
        (val) => val.trim().length > 0,
        'Số điện thoại không được chỉ chứa khoảng trắng'
      ),
    email: z
      .string()
      .email('Email không hợp lệ')
      .max(100, 'Email không được vượt quá 100 ký tự'),
    bankName: z
      .string()
      .optional()
      .or(z.literal(''))
      .refine(
        (val) => !val || val.length <= 100,
        'Tên ngân hàng không được vượt quá 100 ký tự'
      ),
    bankAccountNumber: z
      .string()
      .optional()
      .or(z.literal(''))
      .refine(
        (val) => !val || val.length <= 20,
        'Số tài khoản không được vượt quá 20 ký tự'
      ),
    bankAccountHolder: z
      .string()
      .optional()
      .or(z.literal(''))
      .refine(
        (val) => !val || val.length <= 50,
        'Chủ tài khoản không được vượt quá 50 ký tự'
      ),
    paymentMethod: z
      .string()
      .optional()
      .or(z.literal(''))
      .refine(
        (val) => !val || val.length <= 100,
        'Phương thức thanh toán không được vượt quá 100 ký tự'
      ),
  })
  .superRefine((data, ctx) => {
    if (data.paymentMethod === 'BANK_TRANSFER') {
      // Validate bankName
      if (!data.bankName || data.bankName.trim().length === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Tên ngân hàng là bắt buộc.',
          path: ['bankName'],
        });
      }

      // Validate bankAccountNumber
      if (
        !data.bankAccountNumber ||
        data.bankAccountNumber.trim().length === 0
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Số tài khoản là bắt buộc.',
          path: ['bankAccountNumber'],
        });
      }

      // Validate bankAccountHolder
      if (
        !data.bankAccountHolder ||
        data.bankAccountHolder.trim().length === 0
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Chủ tài khoản là bắt buộc.',
          path: ['bankAccountHolder'],
        });
      }
    }
  });

export type SupplierFormValues = z.infer<typeof supplierFormSchema>;
